<template>
    <div class="col-12">
        <div class="d-flex mb-1">
            <div class="flex-shrink-0">
                <img
                    :src="contract.avatar.src"
                    class="avatar-image me-1"
                    :alt="contract.avatar.alt"
                >
            </div>
            <div class="flex-grow-1 align-self-center">
                <ob1-capsule
                    :label="contractName(contract)"
                    is-information
                    data-cs-encrypt
                />
            </div>
        </div>
        <div class="desktop-contract-wrapper">
            <div class="d-flex align-items-center desktop-contract-card-image">
                <img
                    v-if="contract.imageDevice"
                    :src="contract.imageDevice.src"
                    :alt="contract.imageDevice.alt"
                    class="w-100 h-100"
                >
                <span v-else class="icon icon-device-smart-phone" aria-hidden="true" />
            </div>

            <ob1-cards
                :is-multiple="true"
                :with-composite-link="false"
                class="d-flex flex-row flex-wrap desktop-contract-card py-1 pe-2 ps-5"
            >
                <div v-if="contract.withDroMessage" class="alert-wrapper">
                    <zone-contracts-alert
                        :message="contract.labels.droMessage"
                        :link-url="contract.changeDeviceLinkUrl"
                    />
                </div>
                <div class="pe-2 desktop-contract-card-item">
                    <div class="h4 py-0 my-auto">
                        {{ contract.labels.changeDeviceLabel }}
                    </div>
                    <ul class="items-list row">
                        <li class="col-12">
                            <a
                                :href="contract.changeDeviceLinkUrl"
                                class="items-list-item"
                                :data-oevent-category="contract.tmsChangeDevice.tagZone + (index + 1)"
                                :data-oevent-action="contract.tmsChangeDevice.tagName"
                                :data-oevent-label="contract.changeDeviceLinkUrl"
                            >
                                <div class="item-container no-border-bottom">
                                    <div class="item-text">
                                        <span>{{ contract.descriptionDevice }}</span>
                                        <small class="item-desc">{{ contract.labels.changeDeviceText }}</small>
                                    </div>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="px-2 desktop-contract-card-item">
                    <div class="h4 py-0 my-auto">
                        {{ contract.labels.changeOfferLabel }}
                    </div>
                    <ul class="items-list row">
                        <li class="col-12">
                            <a
                                :href="contract.changeOfferLinkUrl"
                                class="items-list-item"
                                :data-oevent-category="contract.tmsChangeOffer.tagZone + (index + 1)"
                                :data-oevent-action="contract.tmsChangeOffer.tagName"
                                :data-oevent-label="contract.changeOfferLinkUrl"
                            >
                                <div class="item-container no-border-bottom">
                                    <div class="item-text">
                                        <span>{{ contract.mainOfferLabel }}</span>
                                        <small class="item-desc">{{ contract.labels.changeOfferText }}</small>
                                    </div>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="ps-2 desktop-contract-card-item">
                    <h4 class="lead text-gray3 fw-bold my-auto">
                        {{ contract.labels.manageOfferLabel }}
                    </h4>
                    <ob1-liens
                        class="pb-0"
                        :text="contract.labels.manageOfferLink1"
                        :href="contract.manageOfferLink1Url"
                        with-arrow
                        :data-oevent-category="contract.tmsManageOffer1.tagZone + (index + 1)"
                        :data-oevent-action="contract.tmsManageOffer1.tagName"
                        :data-oevent-label="contract.manageOfferLink1Url"
                    />
                    <ob1-liens
                        :text="contract.labels.manageOfferLink2"
                        :href="contract.manageOfferLink2Url"
                        with-arrow
                        :data-oevent-category="contract.tmsManageOffer2.tagZone + (index + 1)"
                        :data-oevent-action="contract.tmsManageOffer2.tagName"
                        :data-oevent-label="contract.manageOfferLink2Url"
                    />
                </div>
            </ob1-cards>
        </div>
    </div>
</template>
<script>

import ZoneContractsAlert from "./ZoneContractsAlert.vue";

export default {
    components: {ZoneContractsAlert},
    props: {
        contract: {
            type: Object,
            required: true
        },
        index: {
            type:Number,
            required: true
        },
    },
    methods: {
        contractName(contract) {
            let msisdn = PhoneFormatter.toFrench(contract.msisdn)
            if (contract.firstName)
                return 'Pour ' + contract.firstName + ' - ' + contract.mainOfferLabel + ' / ' + msisdn
            else return 'Pour la ligne' + contract.firstName + ' - ' + contract.mainOfferLabel + ' / ' + msisdn
        },
    },
}
</script>
<style scoped lang="scss">
@import 'ob1_variables';

.desktop-contract-wrapper {
    margin-left: 38px;
    position: relative;
}

.desktop-contract-card {
    position: relative;
    transition: .2s ease;
}

.desktop-contract-card-item {
    flex: 1;
    z-index: 2;
}

.desktop-contract-card-image {
    height: calc(100% - 5px);
    left: 0;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
}

.desktop-contract-card-image img {
    max-height: 140px;
    object-fit: contain;
}

.desktop-contract-card-image .icon {
    font-size: 94px;
    margin-top: 7px;
}

.icon-device-smart-phone::before {
    background-color: white;
}

.avatar-image {
    width: 32px;
    height: 32px;
}

.alert-wrapper {
    flex-basis: 100%;
}

</style>
